import { useLocation } from 'react-router';
import QueryString from 'qs';
import data from '../../models/data';

interface ClientUserIdInputProps {
  name: string;
}

export function ClientUserIdInput({ name }: ClientUserIdInputProps) {
  const { search } = useLocation();

  const { client_user_id: clientUserId } = QueryString.parse(search, {
    ignoreQueryPrefix: true
  });
  const {
    brandingInfo: { clientId }
  } = data;

  if (!clientUserId || typeof clientUserId !== 'string') return null;

  return (
    <input
      type="hidden"
      name={name}
      value={JSON.stringify({
        [clientId]: clientUserId
      })}
      data-testid="client-user-id-input"
    />
  );
}
